module.exports = __webpack_public_path__ + "img/sec-290-bukuk.7d31c795.svg";